var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1315_657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1903 22.0734L22.1957 22.0725V14.0625C22.1957 10.1439 21.3521 7.12541 16.7711 7.12541C14.5688 7.12541 13.091 8.33392 12.4876 9.47963H12.4239V7.49124H8.08039V22.0725H12.6032V14.8524C12.6032 12.9514 12.9636 11.1131 15.3178 11.1131C17.6374 11.1131 17.672 13.2826 17.672 14.9743V22.0734H22.1903ZM0.715593 7.49215H5.24386V22.0734H0.715593V7.49215ZM2.97791 0.23291C1.53006 0.23291 0.355225 1.40775 0.355225 2.85559C0.355225 4.30343 1.53006 5.50284 2.97791 5.50284C4.42575 5.50284 5.60059 4.30343 5.60059 2.85559C5.6001 2.16016 5.32363 1.49335 4.83189 1.00161C4.34014 0.509864 3.67334 0.233392 2.97791 0.23291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8405,
    height: 21.8405,
    fill: "white",
    transform: "translate(0.355225 0.23291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.422ed30b57d42a3554ea46516587b835.svg";
export { ForwardRef as ReactComponent };